import { observer } from "mobx-react-lite";
import Dialog from "@material-ui/core/Dialog";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import { Image } from "../types";

import { StateService } from "../services/StateService";
import { DraggableImage } from "./DraggableImage";

interface ImageGalleryProps {
  images: Image[];
  state: StateService;
  round: string;
  active: boolean;
  disabled: boolean;
  openImage: (e: any, src: string) => void;
  closeImage: () => void;
  imageIsOpen: boolean;
  image: string;
  submittedImages: string[];
}

export const ImageGallery = observer((props: ImageGalleryProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const checkboxChange = (checked: boolean, img: string) => {

    if(!props.state.authentication.getAuthStatus()) {
      return;
    }

    let selected = props.state.images.getSelection(props.round);

    // if none are selected, set the selected image to rank 1, otherwise,
    // find the first non-empty rank if one does exist (hard coded to 5)
    if (selected.length === 0) {
     props.state.images.selectImage(img, checked, 1);
     return;
    }

    // Check if we are deselecting the image
    let image = props.state.images.getImage(img);

    if (image && checked === false) {
      props.state.images.selectImage(img, checked, 0);
      return;
    }

    for(let i=1; i<=5;++i) {
      if (props.state.images.getSelectionRanked(props.round, i).length === 0 ) {
        props.state.images.selectImage(img, checked, i);
        return;
      }
    }
  };

  return (
    <>
      {props.images
        .slice()
        .sort((a, b) => b.votes - a.votes)
        .map((artImage, i) => {
          return (
            <DraggableImage
              key={i}
              isSelected={artImage.isSelected}
              isWinner={artImage.isWinner}
              winnerIndex={i}
              src={artImage.src}
              thumbnail={artImage.thumbnail}
              caption={artImage.thumbnailCaption}
              active={props.active && !props.disabled}
              disabled={props.disabled}
              votes={artImage.votes}
              openImage={props.openImage}
              checkboxChange={checkboxChange}
              id={artImage.image_id}
              submittedImages={props.submittedImages}
            ></DraggableImage>
          );
        })}
      <Dialog
        fullScreen={fullScreen}
        open={props.imageIsOpen}
        fullWidth={false}
        maxWidth={false}
        onClose={() => props.closeImage()}
      >
        <img
          src={props.image}
          style={{ width: "1024px", height: "1024px" }}
          alt="Art"
        ></img>
      </Dialog>
    </>
  );
});
